import useSettingsStore from '@store/settingsStore'
import CommonPool from 'abis/CommonPool.json'
import { formatPrice } from 'apis/birdeye/helpers'
import CardRow from 'components/CardRow/CardRow'
import { Token, getV2Tokens } from 'config/tokens'
import { useTokenBalances } from 'domain/synthetics/tokens'
import { formatTokenAmount } from 'rfx/lib/numbers'
import { getProvider } from 'rfx/lib/rpc'
import useWallet from 'rfx/lib/wallets/useWallet'
import useSWR from 'swr'
import { cn } from 'utils/classnames'
import commonPoolStore from '@store/commonPoolStore'
import { Contract } from 'utils/ethersImport'

export function VaultStats() {
  const isPro = useSettingsStore((state) => state.isPro())
  const { chainId } = useWallet()
  const provider = getProvider(undefined, chainId)
  const { balancesData } = useTokenBalances(chainId)
  const selectedVault = commonPoolStore((store) => store.selectedVault)
  const commonPoolAddress = selectedVault.value
  const marketToken = Object.values(getV2Tokens(chainId)).find(
    (item) => item.address === commonPoolAddress,
  ) as Token

  const contract = new Contract(commonPoolAddress, CommonPool.abi, provider)
  const { data } = useSWR(`common-pool-assets-${commonPoolAddress}`, {
    fetcher: async () => {
      try {
        const totalAssets = await contract.totalAssets()
        const totalSupply = await contract.totalSupply()
        const symbol = await contract.symbol()
        const name = await contract.name()

        const convertToAssets = await contract.convertToAssets(
          Math.pow(10, 18).toString(), // decimals for share to asset price
        )
        return {
          totalAssets,
          totalSupply,
          convertToAssets,
          symbol,
          name,
        }
      } catch (e) {
        return {
          totalAssets: null,
          totalSupply: null,
          convertToAssets: null,
          symbol: '',
          name: '',
        }
      }
    },
  })
  return (
    <div
      className={cn(
        'flex w-full flex-col justify-center',
        isPro ? 'gap-1' : 'gap-2',
      )}
    >
      <CardRow
        label={`Price`}
        value={formatPrice(data?.convertToAssets * Math.pow(10, -18), 2)}
        className="!w-auto"
      />

      <CardRow
        label={`Wallet`}
        value={
          balancesData
            ? formatTokenAmount(
                balancesData?.[marketToken?.address] || 0,
                marketToken?.decimals,
                '',
                {
                  useCommas: true,
                  displayDecimals: 2,
                },
              )
            : '...'
        }
        className="!w-auto"
      />

      <div className="my-4 h-0 self-stretch outline outline-1 outline-offset-[-0.50px] outline-th-input-border"></div>

      {/* <CardRow
        label={`APR`}
        value={(apr || 0)?.toFixed(4) + '%'}
        className="!w-auto"
      />

      <CardRow
        label={`Total ${commonPoolAsset} Amount of assets`}
        value={formatPrice(Number(data?.totalAssets) * Math.pow(10, -18), 4)}
        className="!w-auto"
      />

      <CardRow
        label={`Total Supply of SLV ${commonPoolAsset} tokens`}
        value={formatPrice(Number(data?.totalSupply * Math.pow(10, -18)), 4)}
        className="!w-auto"
      /> */}
    </div>
  )
}
